import { useEffect } from "react";
import { useDrawDetails } from "../../context/draw-details";
import {
  addNotification,
  setDrawSummary,
  setDrawVariants,
  toggleLoading,
} from "../../state/draw-details/reducer";
import { fetchDraw } from "../../utilities/fetch-draw";
import { requestHelper } from "../../utilities/request-helper";
import noticeError from "../../utilities/notice-error";
import DrawDetails from "../../components/draw-details";
import { Hero } from "../../components/hero";
import { Gallery } from "../../components/gallery";
import FaqAccordion from "../../components/faq-accordion";
import { EnterForm } from "../../components/enter-form";
import { DrawStatus } from "../../components/draw-status";
import styles from "./styles";
import Logo from "../../assets/images/asos-drops-logo.svg";
import { genericError } from "../../constants/notifications";
import { trackPageEvent } from "../../utilities/trackPageEvent";
import DrawUnavailable from "../../components/draw-unavailable";
import { isNativeApp } from "../../components/enter-form/utilities";
import { drawStatus } from "../../constants/draw-status";

export default function DrawDetailsLayout() {
  const [state, dispatch] = useDrawDetails();

  const {
    loading,
    content: { drawId, isIncludedCountry },
    drawDetails: { status },
  } = state;

  useEffect(() => {
    if (!isIncludedCountry && loading) {
      dispatch(toggleLoading());
    }
  }, [dispatch, isIncludedCountry]);

  useEffect(() => {
    const getDrawVariants = async (drawId) => {
      const response = await fetchDraw(requestHelper, drawId, "variants");
      dispatch(setDrawVariants(response));
    };

    const getDrawData = async (drawId) => {
      const response = await fetchDraw(requestHelper, drawId, "summary");

      if (!response) {
        dispatch(addNotification(genericError));
        trackPageEvent({
          content: {
            layout: "limited-drops-message",
            message: "generic error",
          },
        });
      } else {
        dispatch(setDrawSummary(response));
        if (response.status?.toUpperCase() === drawStatus.OPEN) {
          await getDrawVariants(drawId);
        }
      }
    };

    async function getLimitedDropsData() {
      await getDrawData(drawId)
        .then(() => dispatch(toggleLoading()))
        .catch((error) => {
          noticeError(error);
        });
    }

    if (isIncludedCountry) {
      getLimitedDropsData();
    } else {
      trackPageEvent({
        content: {
          layout: "limited-drops-message",
          message: "draw not available",
        },
      });
    }
  }, [dispatch, drawId, isIncludedCountry]);

  useEffect(() => {
    if (isNativeApp()) {
      document.getElementById("chrome-header").style.display = "none";
      document.getElementById("chrome-footer").style.display = "none";
    }
  }, []);

  return (
    <div className={styles.main}>
      {!loading && (
        <>
          {isIncludedCountry && (
            <>
              <div className={styles.logo}>
                <Logo aria-label="asos-drops" role="img" />
              </div>
              <div className={styles.hero}>
                <Hero />
              </div>
              <div className={styles.drawDetails}>
                <div className={styles.drawDetailsContent}>
                  <DrawDetails />
                  {status === "open" ? <EnterForm /> : <DrawStatus />}
                  <FaqAccordion />
                </div>
                <div className={styles.mobileGallery}>
                  <Gallery />
                </div>
              </div>
            </>
          )}
          {!isIncludedCountry && (
            <DrawUnavailable
              title="ASOS Drops"
              message="Sorry, this drop isn't available in your country yet."
            />
          )}
        </>
      )}
    </div>
  );
}
